export default __webpack_public_path__ + "static/media/succulent4.6cde9e73.jpg";